import React, {useState} from "react";
import {Layout, Menu, Breadcrumb, Tabs} from 'antd';
import './style.css'
import ScannerComp from "./scannerComp";
import InfoPageComp from "./InfoPageComp";
import IntroComp from "./IntroductionComp";
const { Header, Content } = Layout;
const {TabPane} = Tabs;


export const PageLayout = () => {
    const [state, setState] = useState({
        scanner: true,
        info: false
    })

    return (
        <Layout className="mainBody">
            <Header className="header">
                <div className="logo" />
                <Menu theme="dark" mode="horizontal" defaultSelectedKeys={['2']}>
                </Menu>
            </Header>
            <Content style={{ padding: '0 50px' }}>
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Introduction" key="1">
                        <IntroComp/>
                    </TabPane>
                    <TabPane tab="X-Ray Scanner" key="2">
                        <ScannerComp/>
                    </TabPane>
                    <TabPane tab="Graphics" key="3">
                        <InfoPageComp/>
                    </TabPane>
                </Tabs>
            </Content>
        </Layout>
    )

}

